/* Copyright (c) 2020-present CloudIO Inc */

import { page as SamplePage } from '../../help/sample_pages/ActionPage';
import { Platform } from '../../platform/Platform';
import { ActionManager, ActionManagerFn } from '../../registry/Component.type';
import { baseActionManager, baseActionProps } from '../../registry/Components';
import { messageType } from '../../registry/constants';
import { defaultValue } from './ActionShowMessage';

const ActionShowMessageManager: ActionManagerFn<'ActionShowMessage'> = (
  platform: Platform,
): ActionManager<'ActionShowMessage'> => {
  return {
    ...baseActionManager(platform, 'ActionShowMessage'),
    defaultValue,
    props: {
      ...baseActionProps,
      message: {
        label: 'Message',
        type: 'expression',
        returnType: async () => 'string',
        required: true,
      },
      type: {
        label: 'Type',
        type: 'select',
        options: messageType,
        required: true,
      },
      timeoutInSec: {
        label: 'Time Out In Seconds',
        type: 'number',
        min: 0,
      },
    },
    name: 'Show Message',
    getDisplayText: (item) => item.props.message.value,
    icon: (item) => ({
      iconName: 'info-circle',
      color: item.props.type,
    }),
    description:
      'Use this action to display a message to the user. You can choose the type of the message to be either Info, Warning, Error or Success. Based on the type, the message will be displayed with the respective theme color background.',
    helpRenders: [
      {
        title: 'Action Show Message',
        description:
          'Try changing the props and press the below button to see it in action!',
        page: SamplePage,
        exampleId: 'e1',
        clearParentChildren: true,
        visibleProps: ['type', 'message'],
        item: {
          children: [],
          itemId: 'actionShowMessage',
          parent: 'triggerOnClick',
          props: {
            message: {
              type: 'expression',
              // eslint-disable-next-line no-template-curly-in-string
              value: '`Hi ${$.session.displayName}!`',
            },
            type: 'info',
          },
          type: 'ActionShowMessage',
        },
      },
    ],
  };
};

export default ActionShowMessageManager;
